module.exports = __webpack_public_path__ + "img/Shopify.e912b331.svg";